import { AdminOrganizationIcsFeedLinkType } from 'api/types';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<AdminOrganizationIcsFeedLinkType>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrganizationIcsFeedLinkReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrganizationIcsFeedLink.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.getAdminOrganizationIcsFeedLink.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.getAdminOrganizationIcsFeedLink.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.getAdminOrganizationIcsFeedLink.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default adminOrganizationIcsFeedLinkReducer;
